import classNames from "classnames";
import { useAppSelector } from "hooks";
import { Fragment } from "react";
import { selectDipState } from "redux/slices";
import { getClassNameVariant } from "components/DIP/helper";
import { OffersStyled } from "./styles";
import OfferItem from "./OfferItem";

interface OffersProps {}

export const Offers: React.FC<OffersProps> = () => {
	const { currentDip } = useAppSelector(selectDipState);

	if (typeof currentDip === "undefined") {
		return <Fragment />;
	}
	const { buttons: data, dip } = currentDip;
	const bouncyChestClass =
		dip.triggerType === "bouncyChestClick" ? "bouncy-chest" : "";

	return (
		<OffersStyled
			className={classNames([
				getClassNameVariant(data?.length as number),
				bouncyChestClass
			])}
		>
			{data?.map((item) => {
				return (
					<OfferItem
						key={item.id}
						item={item}
						buttons={data}
						bouncyChestClass={bouncyChestClass}
					/>
				);
			})}
		</OffersStyled>
	);
};
